import * as Yup from 'yup';

export const isValidEmail = (email?: string): boolean => {
  const schema = Yup.string().required().email();
  return schema.isValidSync(email);
};
